<script setup>
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { saveReportQuery } from '../helpers/reportFilterPersistence';

const route = useRoute();

watch(
  () => route.fullPath,
  () => saveReportQuery(route.params.accountId, route.name, route.query),
  { immediate: true }
);
</script>

<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-6">
    <div class="max-w-5xl mx-auto pb-12">
      <router-view />
    </div>
  </div>
</template>
